import { IxLookupService, IxNgBusyFormService } from 'ix-ng-components';
import { IxKeycloakHttp, IxNgHttpService } from 'ix-ng-http';
import { IxNgCacheService, IxNgRoutingService } from 'ix-ng-routing';
import { IxNgErrorHandlingService, IxNgFormsStaticUtils } from 'ix-ng-forms';
import { inject, Injectable } from '@angular/core';
import { UkrepLookupDTO, UkrepLookupFilterDTO } from './ukrep-lookup.model';

@Injectable()
export class UkrepLookupService extends IxLookupService<
  number,
  undefined,
  UkrepLookupDTO,
  UkrepLookupFilterDTO
> {
  constructor() {
    const ixKeycloakHttp = inject(IxKeycloakHttp);
    const ixNgRoutingService = inject(IxNgRoutingService);
    const ixNgErrorHandlingService = inject(IxNgErrorHandlingService);
    const ixNgHttpService = inject(IxNgHttpService);
    const ixNgBusyFormService = inject(IxNgBusyFormService);
    const ixNgCacheService = inject(IxNgCacheService);

    super(
      ixKeycloakHttp,
      ixNgRoutingService,
      ixNgErrorHandlingService,
      ixNgHttpService,
      ixNgBusyFormService,
      ixNgCacheService,
      'ukrepLookupDTO[]',
      '/lookup/ukrepLookup',
    );
    this.predpomnenje = false;
  }

  filterById(row: UkrepLookupDTO, idSeznam: number[]): boolean {
    return (
      row.siUkrepId !== null && row.siUkrepId !== undefined && idSeznam?.includes(row.siUkrepId)
    );
  }

  searchFunction(row: UkrepLookupDTO, searchValue: string): boolean {
    return (
      // Function defines on which fields you search
      IxNgFormsStaticUtils.searchFunction(searchValue, row.koda) ||
      IxNgFormsStaticUtils.searchFunction(searchValue, row.naziv) ||
      IxNgFormsStaticUtils.searchFunction(searchValue, row.nazivAng) ||
      IxNgFormsStaticUtils.searchFunction(searchValue, row.poglavjeKoda) ||
      IxNgFormsStaticUtils.searchFunction(searchValue, row.poglavjeNaziv) ||
      IxNgFormsStaticUtils.searchFunction(searchValue, row.poglavjeNazivAng)
    );
  }

  getReadUrl(): string {
    return `readSiUkrepLookup`;
  }

  getFilterType(): UkrepLookupFilterDTO {
    return new UkrepLookupFilterDTO();
  }

  /**
   * Function for filtering results after reading results of cached lookup.
   * @param row
   * @param filter
   */
  override customFilter(row: UkrepLookupDTO, filter: UkrepLookupFilterDTO): boolean {
    if (filter.searchValue) {
      if (!this.searchFunction(row, filter.searchValue)) return false;
    }
    return true;
  }
}
